import { type IBaseWidget } from '../../../../IBaseWidget.ts';
import { LabelLayout, WidgetType } from '../../../../Widget.ts';
import { MultiSelectKind } from '../../multi-select/IMultiSelectWidget.ts';
import { SingleSelectKind } from '../../single-select/ISingleSelectWidget.ts';

/**
 * Widget di scelta su cui l'etichetta a blocco può avere effetto: perimetro
 * unico condiviso tra rendering (qui sotto) e default di creazione
 * (`WidgetBlockLabelsLogic`), così le due liste non possono divergere.
 */
export const BLOCK_LABEL_WIDGET_TYPES: readonly WidgetType[] = [
  WidgetType.Boolean,
  WidgetType.Select,
  WidgetType.MultiSelect,
];

/**
 * Etichetta "a blocco" effettiva: `labelLayout = block`, con effetto solo
 * sulle varianti radio/checkbox e mai nelle colonne di tabella.
 * Variante su valori sciolti, per i form di configurazione (valori live).
 */
export function isBlockLabelLayout(params: {
  type?: WidgetType;
  kind?: string;
  labelLayout?: LabelLayout | null;
  isTableColumn?: boolean;
}): boolean {
  if (params.labelLayout !== LabelLayout.Block) return false;
  if (params.isTableColumn) return false;
  if (params.type == null || !BLOCK_LABEL_WIDGET_TYPES.includes(params.type)) {
    return false;
  }

  // Sulle Scelte l'effetto è limitato alle varianti radio/checkbox
  switch (params.type) {
    case WidgetType.Select:
      return params.kind === SingleSelectKind.Radio;
    case WidgetType.MultiSelect:
      return params.kind === MultiSelectKind.Checkbox;
    default:
      return true;
  }
}

/**
 * Come `isBlockLabelLayout`, a partire dal widget salvato.
 * Sui widget fuori perimetro il valore viene conservato ma resta inerte.
 */
export function hasBlockLabelLayout(widget: IBaseWidget): boolean {
  return isBlockLabelLayout({
    type: widget.type,
    kind: (widget as IBaseWidget & { kind?: string }).kind,
    labelLayout: widget.layout?.labelLayout,
    isTableColumn: widget.layout?.isTableColumn,
  });
}
